import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {LayoutDimData, ResizeHelper} from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import {ContinueButton} from "../features/ContinueButton";
import {WGParsedInitData} from "../../server/data/WGParsedInitData";
import {WGParsedGameData} from "../../server/data/WGParsedGameData";
import {WarriorGraveyardGameModuleConfig} from "../../WarriorGraveyardGameModuleConfig";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {StateHandler} from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {WGGameConfig} from "../../WGGameConfig";
import {SoundManager} from "../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../WGSoundConfig";
import {WGStillImageBackground} from "../../background/WGStillImageBackground";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class OutroStates extends StateHandler {
    public static readonly SHOW_BACKGROUND: string = "ShowBackground";
    public static readonly SHOW_LABELS: string = "SHOW_LABELS";
    public static readonly SHOW_FRAME: string = "showFrame";
    public static readonly SHOW_CONTINUE_BTN: string = "showContinueBtn";
}

export class OutroPresentation extends Presentation {
    private _outroButton: ContinueButton;
    private _buttonShowed: boolean = false;
    private outroPresentationSate: OutroStates = new OutroStates();
    private _isSuperFreeSin: boolean = false
    private _outroContainer: PIXI.Container;
    private _outroBackground: PIXI.Sprite;
    // no win stuff
    private _nothingLabel: PIXI.Sprite;
    private _noWinCat: PIXI.Sprite;
    //Labels
    // English
    private _totalWinLabel: PIXI.Sprite;
    private _totalSpinLabel: PIXI.Sprite;
    private _finalMulitplierLabel: PIXI.Sprite;
    //Labels
    // otherLanguages
    private _totalWinLabel_Other: PIXI.Text;
    private _totalSpinLabel_Other: PIXI.Text;
    private _finalMulitplierLabel_Other: PIXI.Text;
    //Countup
    private _totalWinCountup: BitmapCountUp;
    private _totalSpin: PIXI.BitmapText;
    private _finalMultiplier: PIXI.BitmapText;
    //server Value
    private _totalWinAmount: number = 0;
    private _totalSpinACount: number = 0;
    private _finalMultiplierCount: number = 0;
    private _outroFrame: PIXI.spine.Spine;

    // #373
    private _totalWinBelowStake: boolean = false;

    /**
     * override this function to create and add button
     */
    public initialization(): void {
        this._outroContainer = new PIXI.Container();
        this._outroBackground = new PIXI.Sprite(GameResources.getTextures("outroBackground")[0]);
        this._outroBackground.anchor.set(0.5);
        this._outroBackground.position.y = -200;

        this.addChild(this._outroBackground);

        this._outroButton = this.addChild(new ContinueButton(() => {
            this.skipPresentation();
        }));
        this._outroButton.position.y += 100;
        this._outroButton.position.x += 20;

        this.createLabelsAndBitmap();

        this.children.forEach(value => {
            value.visible = false
        });

        this._outroFrame = this.addChildAt(new PIXI.spine.Spine(GameResources.getSpineAsset("intro_outro_spine")), 1);
        this._outroFrame.position.y = -210;
        this._outroFrame.visible = false;

        this.createAndShowLabelsForLanguageOtherThanEnglish();
    }

    /**
     * function to create outro labels and bitmap
     */
    private createLabelsAndBitmap(): void {
        this._totalSpinLabel = new PIXI.Sprite(GameResources.getTextures("Outro/total_spin_text")[0]);
        this._totalWinLabel = new PIXI.Sprite(GameResources.getTextures("Outro/total_win_text")[0]);
        this._finalMulitplierLabel = new PIXI.Sprite(GameResources.getTextures("Outro/final_mult_text")[0]);
        // no win stuff
        this._noWinCat = new PIXI.Sprite(GameResources.getTextures("Outro/Cat")[0]);
        this._nothingLabel = new PIXI.Sprite(GameResources.getTextures("Outro/NothingText")[0]);
        this._noWinCat.scale.set(0.5);
        this._noWinCat.anchor.set(0.5);
        this._nothingLabel.anchor.set(0.5);

        this._totalSpinLabel.anchor.set(0.5);

        this._totalWinLabel.scale.set(1.5);
        this._totalWinLabel.anchor.set(0.5);

        this._nothingLabel.position.y -= 320;
        this._nothingLabel.position.x += 10;
        this._noWinCat.position.x -= 190;
        this._noWinCat.position.y += 40;

        this._finalMulitplierLabel.anchor.set(0.5);

        this._totalWinLabel.position.y -= 400;
        this._totalWinLabel.position.x += 10;

        this._totalSpinLabel.position.y -= 200;
        this._totalSpinLabel.position.x -= this._totalSpinLabel.width / 1.2;

        this._finalMulitplierLabel.position.y -= 208;
        this._finalMulitplierLabel.position.x += this._finalMulitplierLabel.width / 2.3;

        this._totalWinCountup = new BitmapCountUp(
            {
                style: {
                    font: {
                        name: "WGNumbersWinCountUp",
                        size: 15
                    },
                    tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
                }
            });
        this._totalWinCountup.position.y -= 380 - this._totalWinCountup.height;
        this._totalWinCountup.position.x += 10;
        this._totalWinCountup.maxTextWidth = 800;

        this._totalSpin = new PIXI.BitmapText("0", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 15
        });
        this._totalSpin.position.y -= (210 - this._totalSpin.height / 2);
        this._finalMultiplier = new PIXI.BitmapText("0", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 15
        });
        this._finalMultiplier.position.y -= (208 - this._finalMultiplier.height / 2);

        this._outroContainer.addChild(this._totalWinLabel,
            this._totalSpinLabel,
            this._finalMulitplierLabel,
            this._totalWinCountup, this._totalSpin, this._finalMultiplier, this._nothingLabel, this._noWinCat);
        this._outroContainer.visible = false;

        this.addChild(this._outroContainer);
    }

    /**
     * event to call resize function
     */
    public addEventListeners(): void {
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => {
            this.onResize();
        });
    }

    public checkForActivation(data: WGParsedInitData | WGParsedGameData): boolean {
        return data.mode === GameMode.FREESPIN && data.nextMode === GameMode.NORMAL;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this.outroPresentationSate.set(OutroStates.SHOW_BACKGROUND);
        this._totalWinAmount = data.totalWin;
        WGStillImageBackground._isSuperFreespin = false;
        this._isSuperFreeSin = data.superFreespin;
        this._finalMultiplierCount = data.currentMultiplier;
        WGGameConfig.CURRENT_GAME_MODE_BEFORE_SPIN_START = data.nextMode;
        this._totalSpinACount = data.numberOfFreespinsPlayed ? data.numberOfFreespinsPlayed : 0;

        // #373
       // this._totalWinBelowStake = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalWin <= data.playedBetValue));
        this._totalWinBelowStake = WarriorGraveyardGameModuleConfig.featurePrice.isWinBelowStake();
    }

    /**
     * function to set timeline progress to 1 and calling stop from here.
     */
    public skipPresentation(): void {
        this.pTimeline.totalProgress(1);
        SoundManager.playSoundEffect(WGSoundConfig.instance.FS_OUTRO_STONE_DOWN);
        this.PresentationState.set(PresentationState.END);
    }

    /**
     * to show outro presentation do nothing when buttonshowed
     */
    public getPresentation() {
        if (this._buttonShowed) {
            return;
        }
        switch (this.outroPresentationSate.state) {
            case OutroStates.SHOW_BACKGROUND:
                SlotGame.keypad.hide();
                this.fadeInBackground();
                break;
            case OutroStates.SHOW_FRAME:
                this.outroFrameAnimation();
                break;

            case OutroStates.SHOW_LABELS:
                this._outroContainer.visible = true;
                this._outroContainer.children.forEach(value => {
                    value.visible = false;
                });
                if (WGGameConfig.LANGUAGE_OTHER_THAN_EN) {
                    this.ShowLabelsForLanguageOtherThanEnglish();
                } else {
                    this._totalWinLabel.visible = !this._totalWinBelowStake;
                    this._totalSpinLabel.visible = true;
                    this._finalMulitplierLabel.visible = true;

                }
                SoundManager.stopFsLoopFadeeInMainGameLoop();

                // #373
                if (!this._totalWinBelowStake) {
                    if (this._totalWinAmount > 0) {
                        SoundManager.playSoundEffect(WGSoundConfig.instance.FS_END);
                    } else {
                        SoundManager.playSoundEffect(WGSoundConfig.instance.FS_END_NOWIN);
                    }
                }

                let animType: string = this._isSuperFreeSin ? "outro" : "intro_blast";

                if (this._totalWinAmount) {
                    const countUpDuration: number = (this._totalWinBelowStake ? 0 : 1.865); // #373
                    this._totalWinCountup.visible = true;

                    if (countUpDuration > 0) {
                        this.pTimeline.add(() => {
                            SoundManager.playSoundEffect(WGSoundConfig.instance.COUNTUP_SOUND, 1000);
                        }, this.pTimeline.time() + 0.2);
                    }

                    const tl = this._totalWinCountup.getCountUpAnimation(0, this._totalWinAmount, {duration: countUpDuration});
                    this.pTimeline.add(tl);

                    if (countUpDuration > 0) {
                        this.pTimeline.add(() => {
                            SoundManager.stopSoundEffect(WGSoundConfig.instance.COUNTUP_SOUND);
                            SoundManager.playSoundEffect(WGSoundConfig.instance.COUNTUP_END);
                        }, this.pTimeline.duration() - 0.01);
                    }
                } else {
                    animType = this._isSuperFreeSin ? "outro" : "intro"
                    this._nothingLabel.visible = true;
                    this._nothingLabel.tint = this._isSuperFreeSin ? 0xff5157 : 0x6795e8;
                    this._noWinCat.visible = true;
                }
                this.pTimeline.add(() => new SpineTween(this._outroFrame, 0, animType + "_loop", -1));
                // show all labels and coutup from here
                this._finalMultiplier.text = this._finalMultiplierCount.toString();
                this._totalSpin.text = this._totalSpinACount.toString();
                this._finalMultiplier.position.x = this._finalMulitplierLabel.x - (this._finalMultiplier.width / 2);
                this._totalSpin.position.x = this._totalSpinLabel.x - this._totalSpin.width / 2;
                this._totalSpin.visible = true;
                this._finalMultiplier.visible = true;
                this.outroPresentationSate.set(OutroStates.SHOW_CONTINUE_BTN);
                break;
            case OutroStates.SHOW_CONTINUE_BTN:
                // continue button from here
                this._outroButton.alpha = 0;
                this._outroButton.visible = true;
                this.pTimeline.add(this.fadeInoutroButton());
                break;
        }
    }

    private createAndShowLabelsForLanguageOtherThanEnglish(): void {
        const fontConfig: TextStyleOptions = {
            fill: ["#fcee0d", "#f08c09"],
            fillGradientStops: [0.3, 0.6],
            fillGradientType: 0,
            fontSize: 20,
            fontFamily: "Open Sans",
            stroke: "#432207",
            align: "center",
            strokeThickness: 4,
            lineHeight: 20,
            wordWrap: true,
            wordWrapWidth: 250,
        };
        this._totalWinLabel_Other = new PIXI.Text(Translation.translate("TOTAL WIN"), fontConfig);
        this._totalSpinLabel_Other = new PIXI.Text(Translation.translate("TOTAL SPIN"), fontConfig);
        this._finalMulitplierLabel_Other = new PIXI.Text(Translation.translate("FINAL MULTIPLIER"), fontConfig);
        this._totalWinLabel_Other.visible = false;
        this._totalSpinLabel_Other.visible = false;
        this._finalMulitplierLabel_Other.visible = false;

        this._outroContainer.addChild(this._totalSpinLabel_Other, this._totalWinLabel_Other, this._finalMulitplierLabel_Other);

        this._totalWinLabel_Other.style.fontSize = 30;
        this._totalWinLabel_Other.style.lineHeight = 30;
        this._totalWinLabel_Other.style.wordWrapWidth = 300;

        this._totalSpinLabel_Other.anchor.set(0.5);
        this._totalWinLabel_Other.anchor.set(0.5);
        this._finalMulitplierLabel_Other.anchor.set(0.5);

        this._totalWinLabel_Other.position = Helper.copyLocalPosition(this._totalWinLabel_Other, this._totalWinCountup);
        this._totalWinLabel_Other.position.y -= this._totalWinLabel_Other.height;
        this._totalWinLabel_Other.position.x += 20;

        this._totalSpinLabel_Other.position = Helper.copyLocalPosition(this._totalSpinLabel_Other, this._totalSpin);
        this._totalSpinLabel_Other.position.y -= this._totalSpinLabel_Other.height / 2;
        this._totalSpinLabel_Other.position.x -= 150;

        this._finalMulitplierLabel_Other.position = Helper.copyLocalPosition(this._finalMulitplierLabel_Other, this._totalSpin);
        this._finalMulitplierLabel_Other.position.y -= this._finalMulitplierLabel_Other.height / 2;
        this._finalMulitplierLabel_Other.position.x += 130;
    }

    private ShowLabelsForLanguageOtherThanEnglish(): void {
        this._totalWinLabel_Other.visible = !this._totalWinBelowStake;
        this._totalSpinLabel_Other.visible = true;
        this._finalMulitplierLabel_Other.visible = true;
    }

    /**
     * function to play animation on Outro frame.
     */
    private outroFrameAnimation(): void {
        this._outroFrame.position.y += 1000;
        this.playOutroBottomToUpAnimationInSteps();
        this.pTimeline.to({}, 1, {}, 0.5);
        this.outroPresentationSate.set(OutroStates.SHOW_LABELS);
    }

    /**
     * function to introduce frame from down to up.
     */
    private playOutroBottomToUpAnimationInSteps(): void {
        let posY = this._outroFrame.position.y;
        let animType: string = this._isSuperFreeSin ? "outro" : "intro";

        // #373
        if (!this._totalWinBelowStake) {
            this.pTimeline.add(() => {
                if (this._totalWinAmount)
                    SoundManager.playSoundEffect(WGSoundConfig.instance.FS_OUTRO_STONE_COMING);
                else
                    SoundManager.playSoundEffect(WGSoundConfig.instance.FS_OUTRO_STONE_COMING_NO_WIN);
            });
        }

        this.pTimeline.add(
            () => {
                TweenLite.fromTo(this._outroFrame, 1, {y: posY}, {
                    y: posY - 1000,
                    onComplete: () => {
                        if (this._totalWinAmount !== 0) {
                            new SpineTween(this._outroFrame, 0, animType + "_blast");
                        }
                    }
                });
                new SpineTween(this._outroFrame, 0, animType + "_start");
                this._outroFrame.updateTransform();
                this._outroFrame.visible = true;
            });
    }

    /**
     * function to fade in background
     * when presentation starts
     */
    private fadeInBackground(): void {
        this._outroBackground.alpha = 0;
        if (this._isSuperFreeSin)
            this._outroBackground.texture = GameResources.getTextures("outroBackground")[0];
        else
            this._outroBackground.texture = GameResources.getTextures("introBackground")[0];

        this._outroBackground.visible = true;
        this.pTimeline.add(TweenLite.fromTo(this._outroBackground, 1, {alpha: 0}, {alpha: 1}), 0.5);
        this.outroPresentationSate.set(OutroStates.SHOW_FRAME);


    }

    /**
     * function to fade in outro button
     * added 100000000000 in duration to avoid getPresentation calling in loop.
     */
    private fadeInoutroButton(): TimelineLite {
        this._buttonShowed = true;
        let tl: TimelineLite = new TimelineLite();
        tl.add(TweenLite.fromTo(this._outroButton, 0.5, {alpha: 0}, {alpha: 1}));
        tl.add(TweenLite.to(this._outroButton, 100000000000, {}));
        return tl;
    }

    /**
     * stop presenation
     * to hide button, clear variables, set state to inactive.
     */
    public stopPresentation(): void {
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        WarriorGraveyardGameModuleConfig.stickMuliplier.hideReelAreaMulitplier();
        WarriorGraveyardGameModuleConfig.stickWildView._lockedReels = [false, false, false, false, false, false];
        WarriorGraveyardGameModuleConfig.freeSpinLeftMeter.hideFsmeterCountup();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: "NORMAL"}));
        WarriorGraveyardGameModuleConfig.featurePrice.reset();
        this._outroButton.visible = false;
        let outroFadeOut: TimelineMax = new TimelineMax({
            onComplete: () => {
                this._buttonShowed = false;
                this.children.forEach(value => {
                    value.visible = false
                });
                this._outroFrame.position.y -= 1000;
                this._outroContainer.position.y -= 1000;
                this._outroFrame.skeleton.setToSetupPose();
                this._outroFrame.state.tracks = [];
                this._outroFrame.visible = true;
                this._outroFrame.visible = false;
            }
        });
        outroFadeOut.add(TweenLite.fromTo(this._outroFrame, 1, {y: this._outroFrame.position.y}, {y: this._outroFrame.position.y + 1000}), 0);
        outroFadeOut.add(TweenLite.fromTo(this._outroContainer, 1, {y: this._outroContainer.position.y}, {y: this._outroContainer.position.y + 1000}), 0);
        outroFadeOut.add(TweenLite.fromTo(this._outroBackground, 1, {alpha: 1}, {alpha: 0}), 0.2);
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    /**
     * function to resize this.
     */
    public onResize(): void {
        const dimConf = ContinueButton.continueDim;
        let layoutdata: LayoutDimData = ResizeHelper.calcDim(dimConf);
        this.position = layoutdata.position;
        this.scale = layoutdata.scale;
    }
}